import React from "react";
import * as Mui from "@mui/material";
import { Delete, AddCircleOutline } from "@mui/icons-material";
import { themes } from "services/constants";
import { CustomAutoComplete } from "components/CustomComponents";

export const ShiftAssignmentForShift = ({
  shiftError,
  shiftCycleDetails,
  setShiftCycleDetails,
  allGroupDetails,
  setShiftError,
  setUpdateData,
}) => {
  const deleteCycle = (item) => {
    setUpdateData(false);
    const updatedData = shiftCycleDetails
      .filter((data) => data.cycle_number !== item.cycle_number)
      .map((data, index) => ({
        ...data,
        cycle_number: index + 1,
      }));

    setShiftCycleDetails(updatedData);
  };

  const hasIncompleteCycles = () => {
    return shiftCycleDetails.some((cycle) =>
      cycle.assignments.some((a) => !a.shift_name)
    );
  };

  const addNewCycle = () => {
    if (hasIncompleteCycles()) {
      setShiftError(true);
      return;
    }
    setShiftError(false);
    const lastCycle = shiftCycleDetails[shiftCycleDetails.length - 1];

    const newCycle = {
      cycle_number: shiftCycleDetails.length + 1,
      assignments: lastCycle.assignments.map((a) => ({
        shift_name: "",
        shift_id: "",
        shift_group_id: a.shift_group_id,
        shift_group_name: a.shift_group_name,
        shiftDetails: a.shiftDetails,
      })),
    };

    setShiftCycleDetails((prev) => [...prev, newCycle]);
  };

  const updateShiftDetails = (cycleid, groupid) => (event, data) => {
    setUpdateData(false);
    const updatedData = shiftCycleDetails.map((cycle) =>
      cycle.cycle_number === cycleid
        ? {
            ...cycle,
            assignments: cycle.assignments.map((assign) =>
              assign.shift_group_id === groupid
                ? {
                    ...assign,
                    shift_id: data?.id ?? "",
                    shift_name: data?.name ?? "",
                    start_time: data?.start_time,
                    end_time: data?.end_time,
                    color_code: data?.color_code,
                  }
                : assign
            ),
          }
        : cycle
    );
    setShiftCycleDetails(updatedData);
  };

  return (
    <React.Fragment>
      <Mui.Grid container>
        <Mui.Typography sx={{ fontWeight: 600 }}>
          Shift Assignment
        </Mui.Typography>
      </Mui.Grid>
      {shiftCycleDetails?.length !== 0 ? (
        <Mui.Box sx={{ overflowX: "auto" }}>
          <Mui.TableContainer
            sx={{
              marginTop: 2,
              marginLeft: "auto",
              marginRight: "auto",
              overflowX: "auto",
              width: "100%",
              maxWidth: 1300,
            }}
          >
            <Mui.Table
              className="border"
              sx={{
                width: "100%",
                tableLayout: "auto",
                border: "1px solid #0000002b",
              }}
            >
              <Mui.TableHead
                sx={{
                  backgroundColor: themes.primary,
                  position: "sticky",
                  top: -1,
                  zIndex: 10,
                }}
              >
                <Mui.TableRow
                  sx={{
                    "& .MuiTableCell-root": {
                      height: "15px",
                      padding: "6px 5px",
                    },
                  }}
                >
                  <Mui.TableCell
                    sx={{
                      fontSize: 13,
                      borderRight: "1px solid #0000002b",
                      borderBottom: "1px solid #0000002b",
                      verticalAlign: "center",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      backgroundColor: "#f5f5fd",
                      position: "sticky",
                      left: -1,
                      zIndex: 10,
                    }}
                  >
                    Cycle
                  </Mui.TableCell>
                  {allGroupDetails.map((head) => (
                    <Mui.TableCell
                      sx={{
                        fontSize: 13,
                        borderRight: "1px solid #0000002b",
                        borderBottom: "1px solid #0000002b",
                        verticalAlign: "center",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        backgroundColor: "#f5f5fd",
                      }}
                    >
                      {head.name}
                    </Mui.TableCell>
                  ))}
                  <Mui.TableCell
                    sx={{
                      fontSize: 13,
                      borderRight: "1px solid #0000002b",
                      borderBottom: "1px solid #0000002b",
                      verticalAlign: "center",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      backgroundColor: "#f5f5fd",
                    }}
                  >
                    Action
                  </Mui.TableCell>
                </Mui.TableRow>
              </Mui.TableHead>

              <Mui.TableBody>
                {shiftCycleDetails.map((item, index) => (
                  <Mui.TableRow
                    sx={{
                      "& .MuiTableCell-root": {
                        height: "30px",
                        padding: "3px 5px",
                      },
                    }}
                  >
                    <Mui.TableCell
                      sx={{
                        fontSize: 13,
                        borderRight: "1px solid #0000002b",
                        borderBottom: "1px solid #0000002b",
                        verticalAlign: "center",
                        textAlign: "center",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        backgroundColor: "#f5f5fd",
                        position: "sticky",
                        left: -1,
                        zIndex: 10,
                      }}
                    >
                      Cycle {index + 1}
                    </Mui.TableCell>
                    {item?.assignments?.map((head) => (
                      <Mui.TableCell
                        sx={{
                          fontSize: 13,
                          borderRight: "1px solid #0000002b",
                          borderBottom: "1px solid #0000002b",
                          verticalAlign: "center",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          minWidth: 200,
                          maxWidth: 200,
                        }}
                      >
                        <CustomAutoComplete
                          dataList={head?.shiftDetails?.map((obj) => ({
                            ...obj,
                            label: obj?.name,
                          }))}
                          selectedValue={head?.shift_name}
                          updateDataFunction={updateShiftDetails(
                            item?.cycle_number,
                            head?.shift_group_id
                          )}
                          placeHolder="Select the shift"
                        />
                        {head?.shift_name === "" && shiftError ? (
                          <Mui.Typography
                            variant="body2"
                            color="error"
                            sx={{
                              fontSize: 13,
                              paddingLeft: 0.5,
                              textAlign: "left",
                            }}
                          >
                            Shift is required
                          </Mui.Typography>
                        ) : null}
                      </Mui.TableCell>
                    ))}
                    <Mui.TableCell sx={{ textAlign: "center" }}>
                      <Mui.Box sx={{ display: "inline-block" }}>
                        <Mui.IconButton
                          onClick={() => {
                            deleteCycle(item);
                          }}
                          disabled={shiftCycleDetails?.length === 1}
                        >
                          <Delete />
                        </Mui.IconButton>
                      </Mui.Box>
                    </Mui.TableCell>
                  </Mui.TableRow>
                ))}
              </Mui.TableBody>
              <Mui.TableBody>
                <Mui.TableRow>
                  <Mui.TableCell
                    colSpan={1 + allGroupDetails.length + 1}
                    sx={{ textAlign: "right" }}
                  >
                    <Mui.IconButton onClick={addNewCycle}>
                      <AddCircleOutline />
                    </Mui.IconButton>
                  </Mui.TableCell>
                </Mui.TableRow>
              </Mui.TableBody>
            </Mui.Table>
          </Mui.TableContainer>
        </Mui.Box>
      ) : null}
    </React.Fragment>
  );
};
